export const jobSchedulingSearchDefaultOptions = [
  {
    key: "All",
    value: "All",
  },
  {
    key: "CompanyName",
    value: "Company Name",
  },
  {
    key: "ContactName",
    value: "Contact Name",
  },
  {
    key: "CustomerLocation",
    value: "Contact Location",
  },
  {
    key: "HoseName",
    value: "Hose Name",
  },
  {
    key: "HoseId",
    value: "Hose Tag",
  },
  {
    key: "JobNumber",
    value: "Job Number",
  },
  {
    key: "HoseOemNumber",
    value: "OEM Part Number",
  },
  {
    key: "CustomerPurchaseOrderNumber",
    value: "Purchase Order",
  },
  {
    key: "InvoiceNumber",
    value: "Xero Invoice",
  },
];

export const monthOptions = [
  { key: 0, text: "January", value: 0 },
  { key: 1, text: "February", value: 1 },
  { key: 2, text: "March", value: 2 },
  { key: 3, text: "April", value: 3 },
  { key: 4, text: "May", value: 4 },
  { key: 5, text: "June", value: 5 },
  { key: 6, text: "July", value: 6 },
  { key: 7, text: "August", value: 7 },
  { key: 8, text: "September", value: 8 },
  { key: 9, text: "October", value: 9 },
  { key: 10, text: "November", value: 10 },
  { key: 11, text: "December", value: 11 },
];
